export const EventBroker = {
  callType: '',
  subscribe: function (event, fn) {
    $(this).unbind(event, fn);
    $(this).bind(event, fn);
  },
  unsubscribe: function (event, fn) {
    $(this).unbind(event, fn);
  },
  broadcast: function (event) {
    $(this).trigger(event);
  },
};
